import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class LayoutGeneral extends Vue {
  get getHeader() {
    const name = this.$route.name;
    return name !== "checkout";
  }
}
